import { getDashboard } from "../../api/dashboard";
import { VESSEL_TYPE } from "../../constants/constants";
import { ENGINE_POSITION } from "../../constants/trendGraph/enginesLine";
import { GRAPH_TYPE } from "../../constants/trendGraph/trendGraphType";
import { alphabeticalSortCompareFunction } from "../../util/util";
import {
  DASHBOARD_ADDITIONAL_ELECTRIC_TREND_TYPE,
  DASHBOARD_ELECTRIC_TREND_TYPE,
  DASHBOARD_ENGINE_TREND_TYPE,
  DASHBOARD_SEP_TREND_TYPE,
} from "./constants";

export const getSortedDashboards = async (vesselId) => {
  const data = await getDashboard(vesselId);
  if (data.Data.length > 0) {
    const sortedDashboards = data.Data.sort((a, b) =>
      alphabeticalSortCompareFunction(a.name, b.name, "asc")
    );
    return sortedDashboards;
  }
  return [];
};

export const createDashboardChartsList = (vessel, customCharts = []) => {
  const isSepVessel = vessel.vesselType === VESSEL_TYPE.SEP;
  let returnedArray = [];
  if (isSepVessel) {
    returnedArray = [...DASHBOARD_SEP_TREND_TYPE, ...DASHBOARD_ADDITIONAL_ELECTRIC_TREND_TYPE];
    if (customCharts?.charts) {
      returnedArray = [
        ...returnedArray,
        ...customCharts.charts.map((chart) => ({ ...chart, graphType: GRAPH_TYPE.CUSTOM })),
      ];
    }
    return returnedArray;
  }
  // engine vessel case
  // if some vessel has 3 or more engine, we have to update here
  if (vessel.NoME === 1) {
    // if vessel has main engine, chart list has engine trend
    returnedArray = [...returnedArray, ...DASHBOARD_ENGINE_TREND_TYPE(ENGINE_POSITION.CENTER)];
  } else if (vessel.NoME === 2) {
    returnedArray = [
      ...returnedArray,
      ...DASHBOARD_ENGINE_TREND_TYPE(ENGINE_POSITION.PORT),
      ...DASHBOARD_ENGINE_TREND_TYPE(ENGINE_POSITION.STARBOARD),
    ];
  }
  if (vessel.NoDG > 0 || vessel.NoSG > 0) {
    // if vessel has generator engine or shaft generator engine, chart list has electric trend
    returnedArray = [...returnedArray, ...DASHBOARD_ELECTRIC_TREND_TYPE];
  }
  if (customCharts?.charts) {
    returnedArray = [
      ...returnedArray,
      ...customCharts.charts.map((chart) => ({ ...chart, graphType: GRAPH_TYPE.CUSTOM })),
    ];
  }
  return returnedArray;
};

export const getPositionPercentage = (position, element) => {
  const bounds = element.getBoundingClientRect();
  return {
    x: (position.x) / bounds.width,
    y: position.y / bounds.height,
  };
}

export const getPositionValue = (position, element) => {
  const bounds = element.getBoundingClientRect();
  return {
    x: (position.x * bounds.width),
    y: position.y * bounds.height,
  };
}
